import { apiClient } from "api";
import { TReportFields, TReportFilters, TReportList, TReportParameters, TReportTypePicklist, TReportUserParameters, TReportUsers } from "./models/types"

const API_URL = "/Report";

export const getReportsForUser = async (
  accountId: string,
  userId: string
): Promise<TReportList[]> => {
  if (!accountId || !userId) {
    throw new Error("Both accountId and userId must be provided.");
  }
  const response = await apiClient.get<TReportList[]>(`${API_URL}/${accountId}/${userId}`);
  return response.data;
};

export const getReportParameters = async (accountId: string, userId: string, reportName: string): Promise<TReportParameters[]> => {
  if (!accountId || !userId) {
    throw new Error("Both accountId and userId must be provided.");
  }
  const response = await apiClient.get<TReportParameters[]>(`${API_URL}/${accountId}/${userId}/report-parameters?reportName=${encodeURIComponent(reportName)}`);
  return response.data;
};

export const getReportUsers = async (accountId: string, userId: string, userParameters: TReportUserParameters): Promise<TReportUsers[]> => {
  if (!accountId || !userId) {
    throw new Error("Both accountId and userId must be provided.");
  }
  const response = await apiClient.post<TReportUsers[]>(`${API_URL}/${accountId}/${userId}/report-users`, userParameters);
  return response.data;
};

export const getReportForAccount = async (accountId: string, userId: string): Promise<String[]> => {
  if (!accountId || !userId) {
    throw new Error("Both accountId and userId must be provided.");
  }
  const response = await apiClient.get<String[]>(`${API_URL}/${accountId}/${userId}/reports`);
  return response.data;
};

export const saveReportAccessForUser = async (accountId: string, userId: string, selectedUserId: string, reports: string[]): Promise<void> => {
  if (!accountId || !userId || !selectedUserId) {
    throw new Error("Both accountId, selectedUserId and userId must be provided.");
  }
  const response = await apiClient.post<void>(`${API_URL}/${accountId}/${userId}/reports/${selectedUserId}`, reports);
};

export const getReportForAccountAndUser = async (accountId: string, userId: string, selectedUserId: string): Promise<String[]> => {
  if (!accountId || !userId) {
    throw new Error("Both accountId and userId must be provided.");
  }
  const response = await apiClient.get<String[]>(`${API_URL}/${accountId}/${userId}/reports/${selectedUserId}`);
  return response.data;
};

export const getReport = async (accountId: string, userId: string, reportName: string, reportParameters: TReportFilters): Promise<Blob> => {
  if (!accountId || !userId) {
    throw new Error("Both accountId and userId must be provided.");
  }
  const response = await apiClient.post(`${API_URL}/${accountId}/${userId}/report?reportName=${encodeURIComponent(reportName)}`, reportParameters, {
    responseType: 'blob',
  });

  return response.data; 
};